<template>
  <div v-show="drawerVisible">
    <el-drawer
      title="已有人员开卡"
      ref="drawer"
      :visible.sync="drawerVisible"
      :close-on-press-escape="false"
      @close="colseDrawer"
      :wrapperClosable="false"
      size="78%"
    >
      <div class="wrapper">
        <div class="row optional"></div>
        <el-row :gutter="20">
          <el-form
            ref="searchForm"
            :model="searchForm"
            label-width="70px"
            size="small"
            v-enterToNext="true"
          >
            <el-col :lg="4" :md="8" :sm="12" :xs="24">
              <el-form-item label="人员状态" prop="isInsder">
                <el-select
                  v-model="searchForm.state"
                  clearable
                  style="width: 100%"
                  placeholder="请选择状态"
                >
                  <el-option
                    v-for="item in statusList"
                    :key="item.Value"
                    :label="item.value"
                    :value="item.num"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="4" :md="8" :sm="12" :xs="24">
              <el-form-item label="在职单位" prop="isStore">
                <el-select
                  v-model="searchForm.entryFactoryId"
                  clearable
                  filterable
                  @change="PositionList2"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in companyList"
                    :key="item.Id"
                    :label="item.customerName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="4" :md="8" :sm="12" :xs="24">
              <el-form-item label="职位" prop="isStore">
                <el-select
                  v-model="searchForm.entryPositionId"
                  clearable
                  filterable
                  placeholder="请选择职位"
                >
                  <el-option
                    v-for="item in positionList"
                    :key="item.id"
                    :label="item.positionName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="4" :md="8" :sm="12" :xs="24">
              <el-form-item
                label-width="100px"
                label="是否有身份证"
                prop="isStore"
              >
                <el-select
                  v-model="searchForm.isHaveIdentityCard"
                  clearable
                  filterable
                  placeholder="请选择是否有身份证"
                >
                  <el-option label="是" :value="true"></el-option>
                  <el-option label="否" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="4" :md="12" :sm="12" :xs="24">
              <el-form-item label="关键字" prop="keyWord">
                <el-input
                  @keyup.enter.native="handleSearch"
                  v-model="searchForm.keyWord"
                  clearable
                  placeholder="请输入关键字查询"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form>
          <el-button
            size="small"
            style="margin-left: 15px"
            type="primary"
            plain
            @click="handleSearch"
            icon="el-icon-search"
            >查询</el-button
          >
          <!-- <el-button
            size="small"
            style="float: right; margin-right: 15px"
            type="primary"
            icon="el-icon-plus"
            @click="addPersonnel"
            >新增人员</el-button
          > -->
          <p
            style="
              float: right;
              margin-right: 15px;
              margin-top: 10px;
              text-decoration: underline;
              cursor: pointer;
              color: #409eff;
            "
            @click="addPersonnel"
          >
            点击新增人员
          </p>
        </el-row>
        <p style="color: #e6a23c">
          提示：没有手机号码的人员将不会显示，建议员工完善手机号码！
        </p>
        <div class="row table">
          <MyTable
            :tableData="tableData"
            :tableConfig="tableConfig"
            tableType="selection"
            @selectionChange="handleSelectionChange"
            :promoter="true"
            :rowClickFlag="true"
            :height="tableHeight"
            :indexFlag="true"
            @EmptyBtn="EmptyBtn"
            tableEmptyText="暂无数据，请前往人员管理"
          >
            <template v-slot:index="slotData">
              {{
                ($refs.pagination.currentPage - 1) * $refs.pagination.pageSize +
                slotData.scope.$index +
                1
              }}
            </template>
            <template v-slot:state="slotData">
              {{ slotData.scope.row.state | state }}
            </template>

            <template v-slot:operation="slotData">
              <el-button
                @click="editCustomerInfo(slotData.scope.row)"
                class="chabtn"
                size="small"
                icon="el-icon-edit"
                >设为发薪卡</el-button
              >
              <el-button
                @click="deleteCustomer(slotData.scope.row.id)"
                type="danger"
                plain
                size="small"
                icon="el-icon-delete"
                >删除</el-button
              >
            </template>
          </MyTable>

          <Pagination
            style="margin-top: 10px"
            :total="total"
            @getNewData="getPersonnelList"
            ref="pagination"
          />
        </div>

        <div class="submit-bar">
          <el-button @click="colseDrawer" :loading="submitLoading"
            >关 闭</el-button
          >
          <el-button type="primary" :loading="submitLoading" @click="onSubmit"
            >确 定</el-button
          >
        </div>
      </div>
    </el-drawer>
    <el-dialog
      title="提示"
      :visible.sync="tipVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px"
      @close="closeDialog"
    >
      <div class="tip">
        确认发送开卡通知吗？您也可以直接将下述二维码转发给对方，进行开卡。如您打算使用其它通知，请勾选其它通知。
        <div v-for="item in bankInfoList" :key="item.bankId">
          <div style="margin-top: 10px; display: flex">
            {{ item.bankName }} &nbsp;
            <img
              style="width: 140px"
              :src="item.imgPath"
              alt=""
              v-if="$shareType == 2"
            />
            <div
              :id="item.bankName"
              :ref="item.bankName"
              v-if="$shareType == 1"
            ></div>
          </div>
        </div>
        <div class="checkGroup">
          <el-checkbox-group v-model="checkboxGroup" size="small">
            <el-checkbox label="1" border disabled>小程序内通知</el-checkbox>
            <el-checkbox label="2" border>短信通知</el-checkbox>
            <el-checkbox label="3" border>小程序订阅通知</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          :loading="submitLoading"
          @click="
            () => {
              resetForm();
              tipVisible = false;
            }
          "
          >关 闭</el-button
        >
        <el-button
          size="small "
          type="primary"
          :loading="submitLoading"
          @click="confirm('form')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <AddPersonel
      :drawerShow="addCustomerDrawerShow"
      :title="drawerTitle"
      operation="add"
      type="0"
      @colseDrawer="addCustomerDrawerShow = false"
      @refreshData="
        () => {
          getPersonnelList();
        }
      "
    />
  </div>
</template>

<script>
import AddPersonel from "../talent_center/AddTalent.vue";
import QRCode from "qrcodejs2";
import { baseUrl } from "../../request/url";
import { GetUnlimitedQRCodeMinix } from "@/utils/mixin";
import MyTable from "@/components/Table";
export default {
  components: {
    MyTable,
    AddPersonel,
  },
  mixins: [GetUnlimitedQRCodeMinix],

  props: {
    bankInfoList: Array,
    visible: {
      default: false,
      type: Boolean,
      require: true,
    },
    row: {
      default: () => {
        return {};
      },
      type: null,
      require: true,
    },
    onerow: {
      type: null,
    },
  },
  data() {
    return {
      tableName: "batchAddTable",
      tableConfig: [
        {
          field: "cname",
          label: "姓名",
          align: "center",
          width: 130,
          flag: true,
        },
        {
          field: "sex",
          label: "性别",
          align: "center",
          width: 130,
          flag: true,
        },
        {
          field: "identityCard",
          label: "身份证号",
          align: "center",
          width: 180,
          flag: true,
        },
        {
          field: "tel",
          label: "手机号码",
          align: "center",
          width: 140,
          flag: true,
        },
        {
          field: "state",
          label: "人员状态",
          slotName: "state",
          align: "center",
          width: 110,
          flag: true,
        },
        {
          field: "entryFactory",
          label: "在职单位",
          align: "center",
          minWidth: 160,
          flag: true,
        },
        {
          field: "entryPosition",
          label: "职位",
          align: "center",
          minWidth: 90,
          flag: true,
        },
        // {
        //   field: "positionName",
        //   label: "平台开卡",
        //   align: "center",
        //   width: 110,

        //   flag: true,
        // },
      ],
      rules: {
        bank: [
          {
            required: true,
            message: "请选择银行",
            trigger: ["blur", "change"],
          },
        ],
      },
      drawerVisible: false,
      form: {
        img: [],
      },
      submitLoading: false,
      searchForm: {},
      baseUrl: baseUrl,
      tipVisible: false,
      dialogVisible: false,
      addCustomerDrawerShow: false,
      drawerTitle: "",
      loading: false,
      checkboxGroup: ["1"],
      tableData: [],
      total: 0,
      companyList: [],
      tableHeight: "",
      Ids: [],
      toPage: "",
      statusList: [
        {
          value: "待处理",
          num: 1,
        },
        {
          value: "待面试",
          num: 2,
        },
        {
          value: "面试未通过",
          num: 3,
        },
        {
          value: "待入职",
          num: 4,
        },
        {
          value: "未入职",
          num: 5,
        },
        {
          value: "已入职",
          num: 6,
        },
        {
          value: "已离职",
          num: 8,
        },
        {
          value: "已离职(自离)",
          num: 7,
        },
      ],
      customerIds: [],
      positionList: [],
      checked: false,
    };
  },
  filters: {
    state(num) {
      if (num == 1) {
        return "待处理";
      } else if (num == 2) {
        return "待面试";
      } else if (num == 3) {
        return "面试未通过";
      } else if (num == 4) {
        return "待入职";
      } else if (num == 5) {
        return "未入职";
      } else if (num == 6) {
        return "已入职";
      } else if (num == 7) {
        return "已离职(自离)";
      } else if (num == 8) {
        return "已离职";
      }
    },
  },
  mounted() {
    this.getCompanyList();
  },
  methods: {
    closeDialog() {
      this.checkboxGroup = ["1"];
      if (this.$shareType == 1) {
        this.bankInfoList.forEach((item) => {
          document.getElementById(item.bankName).innerHTML = "";
        });
      }
    },
    qrcode() {
      this.submitLoading = true;

      this.bankInfoList.forEach((item, i) => {
        if (this.$shareType == 1) {
          let qrcode = new QRCode(item.bankName, {
            width: 100, // 设置宽度，单位像素
            height: 100, // 设置高度，单位像素
            text:
              baseUrl.website +
              "/#/pages/webView/transferPage?id=" +
              item.bankAutoIntId +
              "-" +
              item.autoIntId +
              "-" +
              item.userAutoIntId +
              "-" +
              item.CompanyAutoIntId,
            // 设置二维码内容或跳转地址
          });
          console.log(
            baseUrl.website +
              "/#/pages/webView/transferPage?id=" +
              item.bankAutoIntId +
              "-" +
              item.autoIntId +
              "-" +
              item.userAutoIntId +
              "-" +
              item.CompanyAutoIntId
          );
          this.submitLoading = false;
        }
        if (this.$shareType == 2) {
          let sendData = {
            page: "pages/webView/transferPage",
            check_path: false,
            width: 150,
            scene:
              "id=" +
              item.bankAutoIntId +
              "-" +
              item.autoIntId +
              "-" +
              item.userAutoIntId +
              "-" +
              item.CompanyAutoIntId,
          };
          this.toPage = `${baseUrl.appletPage}?scene=${sendData.scene}`;
          this.GetUnlimitedQRCode(sendData).then((res) => {
            item.imgPath = "data:image/png;base64," + res;
            if (this.bankInfoList.length - 1 == i) {
              this.submitLoading = false;
            }
            this.tipVisible = true;
          });
        }
      });
    },
    PositionList2() {
      this.positionList = [];
      if (this.searchForm.entryFactoryId) {
        let sendData = {
          customerId: this.searchForm.entryFactoryId,
        };
        this.$api.posts.PositionAllList(sendData).then((res) => {
          if (res.error === false) {
            this.positionList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    confirm() {
      let sendData = {
        id: this.$route.query.id,
        carType: 4,
        userIdList: this.Ids,
        bankInfoList: this.bankInfoList,
        msgType: this.checkboxGroup.join(),
        toPage: this.toPage,
      };
      this.submitLoading = true;

      this.$api.user.CompanyReferrerCarAdd(sendData).then((res) => {
        this.submitLoading = false;
        if (res.code == 0) {
          this.$message.success("通知成功");
          this.tipVisible = false;
          this.$parent.addCustomerDrawerShow = false;
          this.$parent.noteCard();
          this.colseDrawer();
          console.log(res);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    addPersonnel() {
      this.operation = "add";
      this.addCustomerDrawerShow = true;
      this.drawerTitle = "新增人员";
    },
    EmptyBtn() {
      this.$router.push("/personnelList");
    },
    getCompanyList() {
      this.$api.customer.getAllCustomerList().then((res) => {
        if (res.error === false) {
          this.companyList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleSearch() {
      this.$refs.pagination.currentPage = 1;
      this.$refs.pagination.pageSize = 20;
      this.getPersonnelList();
    },
    addAccount() {
      this.dialogVisible = true;
    },
    colseDrawer() {
      this.resetForm();
      this.drawerVisible = false;
      this.$emit("colseDrawer");
    },
    handleSelectionChange(selection) {
      this.Ids = selection.map((v) => {
        return v.userId;
      });
    },
    onSubmit(formName) {
      if (this.Ids.length <= 0) {
        return this.$message.warning("请至少选择一条数据");
      }
      if (this.$shareType == 1) {
        this.tipVisible = true;
      }
      this.$nextTick(() => {
        this.qrcode();
      });
    },
    getPersonnelList() {
      this.loading = true;
      let Data = "";
      let sendData = {};
      this.$nextTick(() => {
        sendData = {
          pageIndex: this.$refs.pagination.currentPage,
          pageSize: this.$refs.pagination.pageSize,
          state: this.searchForm.state,
          keyWord: this.searchForm.keyWord,
          entryFactoryId: this.searchForm.entryFactoryId,
          isHaveTel: true,
          entryPositionId: this.searchForm.entryPositionId,
          isHaveIdentityCard: this.searchForm.isHaveIdentityCard,
        };
        this.$api.user.CompanyUserListPage(sendData).then((res) => {
          this.loading = false;
          if (!res.error) {
            console.log(res);
            this.tableData = res.data.data;
            this.total = res.data.count;
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },

    resetForm() {
      this.checkboxGroup = ["1"];
      this.customerIds = [];
      this.form = {};
      // this.$refs.form.clearValidate();
    },
  },
  watch: {
    visible(newVal) {
      this.drawerVisible = newVal;
      this.getPersonnelList();
      if (newVal) {
        this.loading = false;
      }
    },
    drawerVisible(newVal) {
      this.$emit("update", newVal);
    },
  },
};
</script>
<style lang="less">
.checkGroup {
  text-align: center;
  margin-top: 25px;

  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #409eff;
    border-color: #409eff;
  }
  .el-checkbox__label {
    display: initial;
  }
  .el-checkbox,
  .el-checkbox__input {
    display: initial;
  }
  .el-checkbox {
    margin-right: 10px;
  }
}
</style>
<style lang="less" scoped>
.tip {
  line-height: 25px;
  text-indent: 2em;
}
.submit-bar {
  position: absolute;
  z-index: 99;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 0;
  background-color: #fff;
  text-align: center;
  border-top: 1px solid #ddd;
  padding-right: 20px;
}
.submit-bar .el-button {
  padding: 8px 20px;
}
.el-table .cell {
  white-space: pre-line !important;
}

.wrapper {
  padding: 10px 20px;
}

button.btn {
  background: #0080ff;
  border: 0px;
  color: #fff;
  padding: 5px 10px;
  margin-right: 10px;
}

button.btn:hover {
  background: #004f9e;
  cursor: pointer;
}

.number-footer {
  width: 100px;
}

.myimg {
  width: 200px;
  height: auto;
}
</style>